// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- bracket access on import.meta.env returns `any`; value is string|undefined from Vite env
const BASE = import.meta.env['VITE_API_BASE'] ?? '';

// Bug real (2026-08-05): antes, cualquier fallo (401 real, 500 transitorio,
// caída de red) se convertía en el mismo `Error` genérico — el caller no
// podía distinguir "tu sesión venció" de "esta request puntual falló".
// ApiError.status permite esa distinción; status:0 marca un fallo de red
// (fetch() nunca llegó a tener respuesta — offline, DNS, CORS) para que un
// caller pueda tratarlo igual que un 5xx (reintentable) y nunca como un 401.
export class ApiError extends Error {
  constructor(message: string, public readonly status: number) {
    super(message);
    this.name = 'ApiError';
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`${BASE}${path}`, {
      method,
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'include',
      body: body !== undefined ? JSON.stringify(body) : null,
    });
  } catch (err) {
    throw new ApiError(err instanceof Error ? err.message : 'Network error', 0);
  }
  if (!res.ok) {
    const err = (await res.json().catch(() => ({}))) as { error?: string };
    throw new ApiError(err.error ?? `HTTP ${res.status}`, res.status);
  }
  return res.json() as Promise<T>;
}

async function upload<T>(path: string, formData: FormData): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`${BASE}${path}`, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'include',
      body: formData,
    });
  } catch (err) {
    throw new ApiError(err instanceof Error ? err.message : 'Network error', 0);
  }
  if (!res.ok) {
    const err = (await res.json().catch(() => ({}))) as { error?: string };
    throw new ApiError(err.error ?? `HTTP ${res.status}`, res.status);
  }
  return res.json() as Promise<T>;
}

export const api = {
  get: <T>(path: string) => request<T>('GET', path),
  post: <T>(path: string, body?: unknown) => request<T>('POST', path, body),
  put: <T>(path: string, body?: unknown) => request<T>('PUT', path, body),
  patch: <T>(path: string, body?: unknown) => request<T>('PATCH', path, body),
  delete: <T>(path: string, body?: unknown) => request<T>('DELETE', path, body),
  upload: <T>(path: string, formData: FormData) => upload<T>(path, formData),
};
